<template>
  <div class="chat-context">
    <div
      class="context-box"
      :class="{ 'is-hidden': item.isFold }"
      v-html="chatModel.escape(item.content)"
      @click="$emit('content-tap', $event, item)"
    ></div>
    <div class="toggle-box" v-if="item.type.search('ARTICLE') && isContentHidden(item)">
      <div class="toggle-seat" v-show="item.isFold"></div>
      <div class="toggle-btn" @click.stop="item.isFold = !item.isFold">
        <span>{{ item.isFold ? "展开" : "收起" }}</span>
        <i class="iconfont" :class="item.isFold ? 'glin-bottom' : 'glin-top'"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    chatModel: Object,
    item: Object
  },

  methods: {
    isContentHidden (child) {
      const scale = 96 / 414
      return child.content.length > window.innerWidth * scale
    }
  }
}
</script>

<style lang="stylus">
.chat-context {
  .context-box {
    h1, h2, h3, h4, h5, h6 {
      margin: 8px 0;
      font-weight: bolder;
      line-height: 1.4;
    }

    h1 {
      font-size: 1.25rem;
    }

    h2 {
      font-size: 1.18rem;
    }

    h3 {
      font-size: 1.1rem;
    }

    h4, h5, h6 {
      font-size: 1rem;
    }

    strong, b {
      font-weight: bolder;
    }

    ol, ul {
      margin: 8px 0;
      padding-left: 20px;
    }

    li + li {
      margin-top: 4px;
    }

    &.is-hidden {
      height: 88px;
      overflow: hidden;
    }
  }

  .toggle-box {
    position: relative;

    .toggle-seat {
      width: 100%;
      height: 20px;
      margin-top: -16px;
      background-image: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0.5),
        rgba(255, 255, 255, 1)
      );
    }

    .toggle-btn {
      color: #193a79;
      text-align: center;
      padding-top: 10px;

      .iconfont {
        font-size: 0.9rem;
        margin-left: 1px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/chatContext.vue